import { FunctionComponent } from 'preact';
import { Book } from '@novelizing/types';
import { BookCard } from './BookCard';
import './BooksGrid.css';

interface BooksGridProps {
  books: Book[];
  lastBookElementRef?: (node: HTMLElement | null) => void;
}

export const BooksGrid: FunctionComponent<BooksGridProps> = ({
  books,
  lastBookElementRef,
}) => {
  return (
    <div className="books-grid">
      {books.map((book, index) => {
        if (lastBookElementRef && books.length === index + 1) {
          return (
            <div ref={lastBookElementRef} key={book.id} className="book-item">
              <BookCard book={book} />
            </div>
          );
        } else {
          return (
            <div key={book.id} className="book-item">
              <BookCard book={book} />
            </div>
          );
        }
      })}
    </div>
  );
};
